import { buildPathForLocale } from '@/lib/intl-seo';
import { generateSlug } from '@/lib/utils';

/** Public seller storefront URL (Trendyol-style magaza page). */
export function buildStorePath(lang, slugOrId) {
  const slug = String(slugOrId || '').trim();
  if (!slug) return buildPathForLocale(lang, ['products']);
  return buildPathForLocale(lang, ['store', slug]);
}

export function getStoreSlugFromProduct(product) {
  if (!product) return null;
  if (product.seller_info?.store_slug) return product.seller_info.store_slug;
  const name = product.seller_info?.store_name || product.seller_name;
  if (name) return generateSlug(name);
  return product.seller_id || null;
}
